<div class="d-flex justify-content-center mt-4 mb-2 w-100">
	<seira-loading *ngIf="loading" />
	<div
		*ngIf="!loading"
		class="py-2 px-3 my-2 me-2 bg-white d-inline-flex flex-row align-items-center rounded shadow-lg card text-tertiary fw-light">
		Não existem dados a serem exibidos.
	</div>
</div>
